import {appSessionStorage} from "../../../../shared/services";

const initialState = () => {
  return {
    hasError: false,
    pickupPoints: [],
    selectedPickupPoint: appSessionStorage.getItem('selected-dpd-pickup-point', null),
    loadingPickupPoints: true,
    customer: appSessionStorage.getItem('dpd-pickup-point-customer-location', {
      zipcode: null,
      lat: 0,
      long: 0,
    }),
  };
}

const getters = {
  hasError: (state) => state.hasError,
  customer: (state) => state.customer,
  pickupPoints: (state) => state.pickupPoints,
  selectedPickupPoint: (state) => state.selectedPickupPoint,
  loadingPickupPoints: (state) => state.loadingPickupPoints,
};

const mutations = {
  SET_LOADING_PICKUP_POINTS(state, status) {
    state.loadingPickupPoints = status;
  },
  SET_PICKUP_POINTS(state, pickupPoints) {
    state.pickupPoints = pickupPoints;
  },
  SET_NO_PICKUP_POINTS(state, hasError) {
    state.hasError = hasError;
  },
  SET_PICKUP_POINT(state, pickupPoint) {
    if (null === pickupPoint) {
      appSessionStorage.removeItem('selected-dpd-pickup-point');
      state.selectedPickupPoint = null;
      return;
    }

    appSessionStorage.setItem('selected-dpd-pickup-point', pickupPoint);
    state.selectedPickupPoint = pickupPoint;
  },
  SET_HAS_ERROR(state, hasError) {
    state.hasError = hasError;
  }
};

const actions = {
  async collectPickupPoints({rootState, commit}) {
    commit('SET_LOADING_PICKUP_POINTS', true);
    commit('SET_NO_PICKUP_POINTS', false);
    try {
      let postcode = rootState['CheckoutAddress']['shippingAddress']['postcode'];
      let countryId = rootState['CheckoutAddress']['shippingAddress']['country_id'];
      if (countryId === 'BE') {
        postcode = postcode + rootState['CheckoutAddress']['shippingAddress']['city']
      }

      const data = await this.$solarClient.get(`/api/checkout/pickup-points/dpd/${postcode}/${countryId}`);

      if (data.data?.original?.status && data.data.original.status === 'error') {
        await commit('SET_NO_PICKUP_POINTS', true);
        await commit('SET_HAS_ERROR', true);
        await commit('SET_PICKUP_POINTS', []);
      }
      else{
        await commit('SET_HAS_ERROR', false);
        await commit('SET_PICKUP_POINTS', data.data);
      }
    } catch (err) {
      await commit('SET_NO_PICKUP_POINTS', true);
      await commit('SET_PICKUP_POINTS', []);
      return;
    } finally {
      commit('SET_LOADING_PICKUP_POINTS', false);
    }

  },
  async collectPickupPointsForZipcode({state, commit}, [zipcode, countryCode]) {
    commit('SET_LOADING_PICKUP_POINTS', true);
    commit('SET_NO_PICKUP_POINTS', false);
    try {
      const data = await this.$solarClient.get(`/api/checkout/pickup-points/dpd/${zipcode}/${countryCode}`);

      if (data.data?.original?.status && data.data.original.status === 'error') {
        await commit('SET_NO_PICKUP_POINTS', true);
        await commit('SET_HAS_ERROR', true);
        await commit('SET_PICKUP_POINTS', []);
      }
      else{
        await commit('SET_HAS_ERROR', false);
        await commit('SET_PICKUP_POINTS', data.data);
      }
    } catch (err) {
      await commit('SET_NO_PICKUP_POINTS', true);
      await commit('SET_PICKUP_POINTS', []);
      return;
    } finally {
      commit('SET_LOADING_PICKUP_POINTS', false);
    }
  },
  setPickupPoint({state, commit}, pickupPoint) {
    commit('SET_PICKUP_POINT', pickupPoint);
    commit('CheckoutGlobal/ADD_EXTENSION_ATTRIBUTE', {
      dpd_pickup_point: pickupPoint['LocationCode'],
    }, {root: true});

    commit('CheckoutPayment/ADD_SHIPPING_OPTIONS', {
      dpd_pickup_point: pickupPoint
    }, {root: true});
  },
  removePickupPoints({commit}) {
    commit('SET_PICKUP_POINT', null);
    appSessionStorage.removeItem('selected-dpd-pickup-point');

    commit('CheckoutPayment/CLEAR_SHIPPING_OPTIONS', undefined, {root: true});
  }
}

const state = initialState();

const CheckoutDPDPickupPoints = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default CheckoutDPDPickupPoints;
